import type { IStep } from '@/components/Step/Step.types'
import type { IButtonStepConfig } from '@/components/Step/StepController/StepController.types'

export const useSteps = (recaptchaRef: Ref<boolean>, submitedRef: Ref<boolean>) => {
  const { t } = useI18n()

  const activeIndex = ref<number>(0)
  const direction = ref<'left' | 'right'>('right')

  const stepsData = [
    { title: t('partners.multisport.steps.step1.title'), isArrow: true },
    { title: t('partners.multisport.steps.step2.title'), isArrow: true },
    { title: t('partners.multisport.steps.step3.title'), isArrow: false },
  ]

  const steps = computed<IStep[]>(() =>
    stepsData.map((step, idx) => ({
      index: idx + 1,
      active: activeIndex.value === idx,
      done: activeIndex.value > idx,
      title: step.title,
      isArrow: step.isArrow,
    })),
  )

  const getActiveStep = computed(() => {
    return steps.value.find((step: IStep) => step.active)
  })

  // disabled when recaptcha is not valid or form has submit.
  const shouldBeDisabledButton = computed(() => {
    return recaptchaRef.value || submitedRef.value
  })

  const getConfigForPreviousStep = computed<IButtonStepConfig>(() => ({
    index: activeIndex.value + 1,
    variant: 'lightGrey',
    disabled: activeIndex.value === 0 || activeIndex.value === 3,
  }))

  const getConfigForNextStep = computed<IButtonStepConfig>(() => ({
    index: activeIndex.value + 1,
    variant: 'lightGrey',
    disabled: activeIndex.value === 2 ? shouldBeDisabledButton.value : false,
    text: activeIndex.value === stepsData.length - 1 ? t('partners.multisport.steps.step3.button') : undefined,
  }))

  const previousClick = () => {
    direction.value = 'left'
    if (activeIndex.value > 0) activeIndex.value--
  }

  const nextClick = () => {
    direction.value = 'right'
    if (activeIndex.value < stepsData.length) activeIndex.value++
  }

  return {
    getActiveStep,
    steps,
    activeIndex,
    direction,
    getConfigForNextStep,
    getConfigForPreviousStep,
    previousClick,
    nextClick,
  }
}
